const Main = () => import('../pages/main')
import ToolRoute from './sideNav/tool.route'
import liveRoute from './sideNav/live.route'
import videoRoute from './sideNav/video.route'
import AiRoute from './sideNav/ai.route'
import WenSiRoute from './sideNav/wenSi.route'
import FlowRoute from './sideNav/flow.route'
import EnquiryRoute from './sideNav/enquiry.route'
import CourseRoute from './sideNav/course.route'
import OrderRoute from './sideNav/order.route'
import AccountRoute from './sideNav/account.route'
import ContractRoute from './sideNav/contract.route'
import RenewalRoute from './sideNav/renewal.route'
import CouponlRoute from './sideNav/coupon.route'
import MessagelRoute from './sideNav/message.route'
import AiteNetworkRoute from './sideNav/aiteNetwork.route'


export default [
	ToolRoute, videoRoute, ...AiRoute, WenSiRoute, FlowRoute, EnquiryRoute, ...CourseRoute, OrderRoute, RenewalRoute, ContractRoute,CouponlRoute,MessagelRoute, AccountRoute,AiteNetworkRoute,
	{
		path: '/main',
		name: 'main',
		redirect: {
			name: 'console'
		},
		component: Main,
		meta: {
			requiresAuth: true
		}
	}]
